export default "__VITE_ASSET__2beb0c9f__"